import React from 'react'
import User from 'components/User'

export default Component => props => (
  <User render={({ user }) => <Component user={user} {...props} />} />
)



// WEBPACK FOOTER //
// ./src/components/withUser.js